var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.28044 1.80652C6.75 2.27677 6.75 3.13694 6.75 4.8573V13.1427C6.75 14.8631 6.75 15.7232 7.28044 16.1935C7.81088 16.6637 8.62165 16.5223 10.2432 16.2395L11.9898 15.9348C13.7857 15.6216 14.6836 15.465 15.2168 14.8063C15.75 14.1476 15.75 13.195 15.75 11.2897V6.71033C15.75 4.80504 15.75 3.85239 15.2168 3.19369C14.6836 2.535 13.7857 2.37838 11.9898 2.06515L10.2432 1.76052C8.62165 1.47769 7.81088 1.33628 7.28044 1.80652ZM9 7.62647C9.31066 7.62647 9.5625 7.89002 9.5625 8.21512V9.78487C9.5625 10.11 9.31066 10.3735 9 10.3735C8.68934 10.3735 8.4375 10.11 8.4375 9.78487V8.21512C8.4375 7.89002 8.68934 7.62647 9 7.62647Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66037 3.375C4.11667 3.37725 3.31199 3.4112 2.79917 3.92402C2.25 4.47319 2.25 5.35707 2.25 7.12484V10.8748C2.25 12.6426 2.25 13.5265 2.79917 14.0757C3.31199 14.5885 4.11667 14.6224 5.66038 14.6247C5.62488 14.1572 5.62494 13.6167 5.62501 13.0326V4.96702C5.62494 4.38291 5.62488 3.84248 5.66037 3.375Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.c4bb40b5.svg";
export { ForwardRef as ReactComponent };